export class AgentDataSpecDto {
  seq?: string;
  name: string;
  label: string;
  type: string;
  source?: string;
  required: boolean;

  constructor(d?: AgentDataSpecDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
